var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerticalDots = function SvgVerticalDots(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 18.84c1.07 0 1.95.88 1.95 1.95 0 1.08-.88 1.96-1.95 1.96a1.955 1.955 0 0 1 0-3.91m0-7.8c1.07 0 1.95.88 1.95 1.96 0 1.07-.88 1.95-1.95 1.95a1.955 1.955 0 0 1 0-3.91m1.95-5.84c0-1.08-.88-1.95-1.95-1.95-1.08 0-1.95.87-1.95 1.95 0 1.07.87 1.95 1.95 1.95 1.07 0 1.95-.88 1.95-1.95"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerticalDots);
export default ForwardRef;